import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { show, hide, toggleVisiblity } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'overlay',
    'heading',
    'form',
    'checkbox',
    'input',
    'hideOnLoad',
    'hideOnSuccess',
    'showOnSuccess',
    'showOnFailure',
    'submitButton',
  ];

  connect() {
    this.hideOnLoadTargets.forEach((element) => hide(element));
    this.submittedSuccessfully = false;

    if (!CurrentUser.isGuest()) {
      return false;
    }

    document.body.addEventListener(
      'form-overlay:set-heading',
      this.setHeading.bind(this)
    );
    this.formTarget.addEventListener(
      'ajax:beforeSend',
      this.ajaxBeforeSend.bind(this)
    );
    this.formTarget.addEventListener(
      'ajax:success',
      this.ajaxSuccess.bind(this)
    );
    this.formTarget.addEventListener('ajax:error', this.ajaxError.bind(this));
  }

  setHeading(event) {
    const { heading } = event.detail;
    this.headingTarget.innerHTML = heading;
    show(this.headingTarget);
  }

  close() {
    hide(this.overlayTarget);

    if (false === this.submittedSuccessfully) {
      Array.from(this.checkboxTargets).forEach((cb) => (cb.checked = false));
    }
  }

  // private

  checkboxTargetConnected(checkbox) {
    checkbox.addEventListener('click', this.handleCheckboxToggled.bind(this));
  }

  handleCheckboxToggled() {
    toggleVisiblity(
      this.overlayTarget,
      this.checkboxTargets.some((checkbox) => checkbox.checked)
    );
  }

  ajaxBeforeSend() {
    this.submitButtonTarget.innerText = 'wird verarbeitet';
    this.submitButtonTarget.disabled = true;
  }

  ajaxSuccess(event) {
    this.submittedSuccessfully = true;
    this.checkboxTargets.forEach((checkbox) => (checkbox.disabled = true));
    this.inputTargets.forEach((input) => (input.disabled = true));

    let messages = event.detail[0].messages || [];
    this.showOnSuccessTarget.innerHTML = messages.join('\n<br/>');
    this.hideOnSuccessTargets.forEach((node) => toggleVisiblity(node, false));
    show(this.showOnSuccessTarget);
    hide(this.showOnFailureTarget);
    hide(this.headingTarget);
  }

  ajaxError(event) {
    let errorMessages = event.detail[0].messages || [];
    this.showOnFailureTarget.innerHTML = errorMessages.join('. ');
    show(this.showOnFailureTarget);
    hide(this.headingTarget);
    this.submitButtonTarget.innerText = 'Newsletter abonnieren';
    this.submitButtonTarget.disabled = false;
  }
}
